const UUID = {
  "06aa1910f22a11e39daa0002a5d5c51b": "/Organization/Nestle_Nespresso_SA/",
  "07775dd0111b11e491910800200c9a66": "/Product/XY-Findables_Beacon/",
  "0d60a2892039442198216b12c4274890": "/Product/Bluetooth_World_2017_Beacon/",
  "2f234454cf6d4a0fadf2f4911ba9ffa6": "/Product/Radius-Networks_Beacon/",
  "3d4f13b4d1fd404980e5d3edcc840b69": "/Product/Orange_Beacon/",
  "52052c11e701478299f58ce88dbb1500": "/Product/Allegion_ENGAGE/",
  "61687109905f443691f8e602f514c96d": "/Product/BlueCats_Beacon/",
  "6e400001b5a3f393e0a9e50e24dcca9e": "/Organization/Nordic_Semiconductor_ASA/",
  "7265656c794163746976652055554944": "/Product/reelyActive_RA-R436/",
  "7265656c7941707020416e64726f6964": "/Product/reelyActive_reelyApp-Android/",
  "7265656c7941707020666f7220694f53": "/Product/reelyActive_reelyApp-iOS/",
  "74278bdab64445208f0c720eaf059935": "/Product/Minew_Beacon/",
  "7a4385c9f7c74e229afd16d68fc588ca": "/Product/SocketMobile_S550/",
  "8deefbb9f7384297804096668bb44281": "/Product/Roximity_Beacon/",
  "adab0bd16e7d4601bda2bffaa68956ba": "/Product/Fitbit_Wearable/",
  "adab0cf56e7d4601bda2bffaa68956ba": "/Product/Fitbit_Wearable/",
  "adab71766e7d4601bda2bffaa68956ba": "/Product/Fitbit_Wearable/",
  "adabfb006e7d4601bda2bffaa68956ba": "/Product/Fitbit_Wearable/",
  "b9407f30f5f8466eaff925556b57fe6d": "/Product/Estimote_Beacon/",
  "cbbfe0e1f7f3420684e084cbb3d09dfc": "/Product/ASUS_Nexus-Player/",
  "d0d3fa86ca7645ec9bd96af4927d7be1": "/Product/Estimote_Beacon/",
  "d2d3f8ef9c994d9ca2b391c85d44326c": "/Product/Nest_Cam/",
  "d5060001a904deb947482c7f4a124842": "/Product/Thalmic-Labs_Myo/",
  "dab59c4fa4d6ee286bfe8e0000bbc2bb": "/Product/Cocoanut-Manor_eNote/",
  "e2c56db5dffb48d2b060d0f5a71096e0": "/Product/Bright_Beacon/",
  "f0018b9b75094c31a9051a27d39c003c": "/Product/Locoslab_Beacon/",
  "f02adfc026e711e49edc0002a5d5c51b": "/Product/Shortcut-Labs_FLIC/",
  "f3077abe93ac465aacf167f080cb7aef": "/Product/The-Bubbles-Company_Beacon/",
  "f7826da64fa24e988024bc5b71e0893e": "/Product/Kontakt_Beacon/"
};

const COMPANY_IDENTIFIERS = {
  "0003": "/Organization/IBM_Corporation/",
  "0004": "/Organization/Toshiba_Corporation/",
  "0006": "/Organization/Microsoft/",
  "000a": "/Organization/CSR/",
  "0044": "/Organization/Socket_Mobile/",
  "004c": "/Organization/Apple_Inc/",
  "0059": "/Organization/Nordic_Semiconductor_ASA/",
  "005f": "/Organization/Wicentric_Inc/",
  "0065": "/Organization/HP_Inc/",
  "006b": "/Organization/Polar_Electro_Oy/",
  "0075": "/Organization/Samsung/",
  "0077": "/Organization/Laird_Connectivity/",
  "0078": "/Organization/Nike_Inc/",
  "0087": "/Organization/Garmin_International/",
  "008a": "/Organization/Jawbone/",
  "008c": "/Organization/Gimbal_Inc/",
  "009e": "/Organization/Bose_Corporation/",
  "00b5": "/Organization/Swirl_Networks_Inc/",
  "00bd": "/Organization/Aplix_Corporation/",
  "00c4": "/Organization/LG_Electronics/",
  "00c7": "/Organization/Quuppa_Oy/",
  "00cc": "/Organization/Beats_Electronics/",
  "00cd": "/Organization/Microchip_Technology_Inc/",
  "00d2": "/Organization/Dialog_Semiconductor_BV/",
  "00df": "/Organization/Misfit_Inc/",
  "00e0": "/Organization/Google/",
  "00f0": "/Organization/PayPal_Inc/",
  "0104": "/Organization/PLUS_Location_Systems/",
  "011b": "/Organization/Aruba_Networks/",
  "012d": "/Organization/Sony_Corporation/",
  "0131": "/Organization/Cypress_Semiconductor_Corporation/",
  "0136": "/Organization/Seed_Labs_Inc/",
  "013a": "/Organization/Tencent_Holdings_Limited/",
  "0147": "/Organization/Mighty_Cast_Inc/",
  "0154": "/Organization/Pebble_Technology_Corporation/",
  "0157": "/Organization/Xiaomi/",
  "015d": "/Organization/Estimote_Inc/",
  "015e": "/Organization/UniKey_Technologies_Inc/",
  "0171": "/Organization/Amazon_com_Services_Inc/",
  "0180": "/Organization/Gigaset_Communications_GmbH/",
  "0195": "/Organization/Zuli_Inc/",
  "01ab": "/Organization/Facebook_Inc/",
  "01b5": "/Organization/Nest_Labs/",
  "01d1": "/Organization/August_Home_Inc/",
  "01da": "/Organization/Logitech_International_SA/",
  "0211": "/Organization/Telink_Semiconductor_Co_Ltd/",
  "0225": "/Organization/Nestle_Nespresso_SA/",
  "027d": "/Organization/Huawei_Technologies_Co_Ltd/",
  "02b2": "/Product/OURA_Ring/",
  "02d3": "/Organization/Powercast_Corporation/",
  "02f2": "/Organization/GoPro_Inc/",
  "0309": "/https://www.dolby.com/",
  "0399": "/Organization/Nikon_Corporation/",
  "03c2": "/Organization/Snapchat_Inc/",
  "03da": "/Organization/EnOcean_GmbH/",
  "0499": "/Organization/Ruuvi_Innovations_Ltd/",
  "0528": "/Organization/Lunera_Inc/",
  "0583": "/Organization/Code_Blue_Communications_Inc/",
  "0590": "/Organization/Pur3_Ltd/",
  "05a7": "/Organization/Sonos_Inc/",
  "060f": "/Organization/Signify/",
  "0639": "/Organization/Shenzhen_Minew_Technologies_Co_Ltd/"
};

// Reference:
// https://www.bluetooth.com/specifications/assigned-numbers/16-bit-uuids-for-members
const UUID16 = {
  "fefd": "/Organization/Gimbal_Inc/",
  "fefc": "/Organization/Gimbal_Inc/",
  "fefa": "/Organization/PayPal_Inc/",
  "fef9": "/Organization/PayPal_Inc/",
  "fef8": "/Organization/Aplix_Corporation/",
  "fef7": "/Organization/Aplix_Corporation/",
  "fef6": "/Organization/Wicentric_Inc/",
  "fef5": "/Organization/Dialog_Semiconductor_BV/",
  "fef4": "/Organization/Google/",
  "fef3": "/Organization/Google/",
  "fef2": "/Organization/CSR/",
  "fef1": "/Organization/CSR/",
  "feef": "/Organization/Polar_Electro_Oy/",
  "feee": "/Organization/Polar_Electro_Oy/",
  "feed": "/Product/Tile_Tile/",
  "feec": "/Product/Tile_Tile/",
  "feeb": "/Organization/Swirl_Networks_Inc/",
  "feea": "/Organization/Swirl_Networks_Inc/",
  "fee7": "/Organization/Tencent_Holdings_Limited/",
  "fee6": "/Organization/Seed_Labs_Inc/",
  "fee5": "/Organization/Nordic_Semiconductor_ASA/",
  "fee4": "/Organization/Nordic_Semiconductor_ASA/",
  "fedd": "/Organization/Jawbone/",
  "fedc": "/Organization/Jawbone/",
  "fed9": "/Organization/Pebble_Technology_Corporation/",
  "fed4": "/Organization/Apple_Inc/",
  "fed3": "/Organization/Apple_Inc/",
  "fed2": "/Organization/Apple_Inc/",
  "fed1": "/Organization/Apple_Inc/",
  "fed0": "/Organization/Apple_Inc/",
  "fecf": "/Organization/Apple_Inc/",
  "fece": "/Organization/Apple_Inc/",
  "fecd": "/Organization/Apple_Inc/",
  "fecc": "/Organization/Apple_Inc/",
  "fecb": "/Organization/Apple_Inc/",
  "feca": "/Organization/Apple_Inc/",
  "fec9": "/Organization/Apple_Inc/",
  "fec8": "/Organization/Apple_Inc/",
  "fec7": "/Organization/Apple_Inc/",
  "fec4": "/Organization/PLUS_Location_Systems/",
  "febe": "/Organization/Bose_Corporation/",
  "feba": "/Organization/Tencent_Holdings_Limited/",
  "feb9": "/Organization/LG_Electronics/",
  "feb8": "/Organization/Facebook_Inc/",
  "feb7": "/Organization/Facebook_Inc/",
  "feb2": "/Organization/Microsoft/",
  "feb0": "/Organization/Nest_Labs/",
  "feaf": "/Organization/Nest_Labs/",
  "feaa": "/Product/Google_Eddystone/",
  "fea6": "/Organization/GoPro_Inc/",
  "fea5": "/Organization/GoPro_Inc/",
  "fea0": "/Product/Google_Chromecast/",
  "fe9f": "/Product/Google_Chromecast/",
  "fe9e": "/Organization/Dialog_Semiconductor_BV/",
  "fe9a": "/Organization/Estimote_Inc/",
  "fe95": "/Organization/Xiaomi/",
  "fe8f": "/Organization/CSR/",
  "fe8b": "/Organization/Apple_Inc/",
  "fe8a": "/Organization/Apple_Inc/",
  "fe86": "/Organization/Huawei_Technologies_Co_Ltd/",
  "fe78": "/Organization/HP_Inc/",
  "fe77": "/Organization/HP_Inc/",
  "fe65": "/Organization/CHIPOLO/",
  "fe61": "/Organization/Logitech_International_SA/",
  "fe59": "/Organization/Nordic_Semiconductor_ASA/",
  "fe58": "/Organization/Nordic_Semiconductor_ASA/",
  "fe56": "/Organization/Google/",
  "fe55": "/Organization/Google/",
  "fe50": "/Organization/Google/",
  "fe4b": "/Organization/Signify/",
  "fe3b": "https://www.dolby.com/",
  "fe36": "/Organization/Huawei_Technologies_Co_Ltd/",
  "fe35": "/Organization/Huawei_Technologies_Co_Ltd/",
  "fe33": "/Organization/CHIPOLO/",
  "fe2c": "/Organization/Google/",
  "fe27": "/Organization/Google/",
  "fe26": "/Organization/Google/",
  "fe25": "/Organization/Apple_Inc/",
  "fe24": "/Organization/August_Home_Inc/",
  "fe21": "/Organization/Bose_Corporation/",
  "fe1f": "/Organization/Garmin_International/",
  "fe19": "/Organization/Google/",
  "fe15": "/Organization/Amazon_com_Services_Inc/",
  "fe13": "/Organization/Apple_Inc/",
  "fe0f": "/Organization/Signify/",
  "fe08": "/Organization/Microsoft/",
  "fe07": "/Organization/Sonos_Inc/",
  "fe03": "/Organization/Amazon_com_Services_Inc/",
  "fe00": "/Organization/Amazon_com_Services_Inc/",
  "fdf7": "/Organization/HP_Inc/",
  "fdf0": "/Organization/Google/",
  "fdee": "/Organization/Huawei_Technologies_Co_Ltd/",
  "fde2": "/Organization/Google/",
  "fddb": "/Organization/Samsung/",
  "fdd2": "/Organization/Bose_Corporation/",
  "fdd1": "/Organization/Huawei_Technologies_Co_Ltd/",
  "fdd0": "/Organization/Huawei_Technologies_Co_Ltd/",
  "fdb4": "/Organization/HP_Inc/",
  "fdab": "/Organization/Xiaomi/",
  "fdaa": "/Organization/Xiaomi/",
  "fd9c": "/Organization/Huawei_Technologies_Co_Ltd/",
  "fd9b": "/Organization/Huawei_Technologies_Co_Ltd/",
  "fd9a": "/Organization/Huawei_Technologies_Co_Ltd/",
  "fd96": "/Organization/Google/",
  "fd8c": "/Organization/Google/",
  "fd8a": "/Organization/Signify/",
  "fd87": "/Organization/Google/",
  "fd84": "/Product/Tile_Tile/",
  "fd82": "/Organization/Sony_Corporation/",
  "fd7e": "/Organization/Samsung/",
  "fd7c": "/Organization/Toshiba_Corporation/",
  "fd72": "/Organization/Logitech_International_SA/",
  "fd6f": "/Service/Contact_Tracing/",
  "fd6c": "/Organization/Samsung/",
  "fd69": "/Organization/Samsung/",
  "fd63": "/Product/Fitbit_Wearable/",
  "fd62": "/Product/Fitbit_Wearable/",
  "fd5a": "/Organization/Samsung/",
  "fd59": "/Organization/Samsung/",
  "fd4b": "/Organization/Samsung/",
  "fd44": "/Organization/Apple_Inc/",
  "fd43": "/Organization/Apple_Inc/",
  "fd36": "/Organization/Google/",
  "fd31": "/Organization/LG_Electronics/",
  "fd2d": "/Organization/Xiaomi/",
  "fd2a": "/Organization/Sony_Corporation/",
  "fd22": "/Organization/Huawei_Technologies_Co_Ltd/",
  "fd21": "/Organization/Huawei_Technologies_Co_Ltd/",
  "fd1d": "/Organization/Samsung/"
};

const APPLE_Continuity = {
  '02': 'iBeacon',
  '03': 'AirPrint',
  '05': 'AirDrop',
  '06': 'HomeKit',
  '07': 'ProximityPairing',
  '08': 'Siri',
  '09': 'AirPlayTarget',
  '0a': 'AirPlaySource',
  '0b': 'MagicSwitch',
  '0c': 'Handoff',
  '0d': 'TetheringTarget',
  '0e': 'TetheringSource',
  '0f': 'NearbyAction',
  '10': 'NearbyInfo',
  '12': 'FindMy'
}

const NearbyInfoActionCode = {
  0x00: 'unknown',
  0x01: 'reporting disabled',
  0x03: 'idle',
  0x05: 'audio + locked',
  0x07: 'active',
  0x09: 'video playing',
  0x0a: 'watch worn + unlocked',
  0x0b: 'recent activity',
  0x0d: 'user driving',
  0x0e: 'call active'
}

const NearbyActionType = {
  0x01: 'Apple TV Setup',
  0x04: 'Mobile Backup',
  0x05: 'Watch Setup',
  0x06: 'Apple TV Pair',
  0x07: 'Internet Relay',
  0x08: 'WiFi Password',
  0x09: 'iOS Setup',
  0x0A: 'Repair',
  0x0B: 'Speaker Setupd',
  0x0C: 'Apple Pay',
  0x0D: 'Whole Home Audio Setup',
  0x0E: 'Developer Tools Pairing Request',
  0x0F: 'Answered Call',
  0x10: 'Ended Call',
  0x11: 'DD Ping',
  0x12: 'DD Pong',
  0x13: 'Remote Auto Fill',
  0x14: 'Companion Link Proximity',
  0x15: 'Remote Management',
  0x16: 'Remote Auto Fill Pong',
  0x17: 'Remote Display'
}

module.exports = {
  UUID, UUID16, COMPANY_IDENTIFIERS, APPLE_Continuity, NearbyInfoActionCode, NearbyActionType
}